var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dynamicBannerData)?_c('DynamicHalfBanner',{attrs:{"type":_vm.type,"desktop-image":_vm.dynamicBannerData.desktopImage,"mobile-image":_vm.dynamicBannerData.mobileImage,"target-path":_vm.dynamicBannerData.targetPath}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }